module.exports = __webpack_public_path__ + "img/banner-one5.2e88f679.png";